import Component from '../../component';
import styles from './mini.module.scss';
import { Subscription } from '../../observer.model';
import { WIDGET_EXISTENCE_ERROR } from '../../../constants';
import { Dentolo } from '../../../dentolo';
import EventEmitter from '../../event-emitter.model';

interface WidgetApi {
	isActive():boolean
	show():void;
	hide():void;
	onClick(callback:(event:MouseEvent)=>void):void
}

export default class RoundWidget extends Component implements WidgetApi {
	private onClickSubscription:Subscription;
	public element:HTMLButtonElement;
	private eventEmitter = new EventEmitter();

	constructor(state: 'active' | 'hidden' = 'active', zIndex:number, posOptions?: Dentolo.MiniWidgetPosition | Dentolo.MiniWidgetCustomPosition, color?: string) {
		super();
		this.element = document.createElement('button');
		this.element.dataset.nameSpace = 'dentolo';
		this.element.style.zIndex = String(zIndex + 10);

		if (typeof posOptions == 'string') this.element.className = styles[posOptions];
		if (typeof posOptions == 'object') {
			this.element.className = styles.default;
			this.element.style.left = posOptions.x + posOptions.unit;
			this.element.style.top = posOptions.y + posOptions.unit;
		}
		if (!posOptions) this.element.className = styles['right-bottom'];

		if (color) this.element.style.backgroundColor = color;

		this.element.onclick = (e) => {
			this.eventEmitter.emit("click", e);
		}
	}

	public isActive():boolean {
		return this.element.className == styles.active;
	}

	public show():void {
		this.element.classList.remove(styles.hidden);
		this.element.classList.add(styles.active);
	}

	public hide():void {
		this.element.classList.remove(styles.active);
		this.element.classList.add(styles.hidden);
	}

	public onClick(callback:(event:MouseEvent)=>void):Subscription {
		return this.eventEmitter.subscribe("click", callback);
	}

	public destructor() {
		this.onClickSubscription.unsubscribe();
		this.onClick = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.hide = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.show = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
		this.isActive = ():never=> { throw new Error(WIDGET_EXISTENCE_ERROR) };
	}
}